module.exports = "<div class=\"heading-title\" [ngClass]=\"\">\n  <h3 class=\"title iq-tw-7\">{{ title }}</h3>\n  <p>{{ subTitle }}</p>\n</div>\n"